import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bibEventComposer } from '@bibliocommons/analytics-event-composers';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import AnalyticsConstants from '@bibliocommons/constants-analytics';
import VendorAttributionLabel from 'app/components/bibs/shared/VendorAttributionLabel';
import AuthorsList from '../AuthorsList';

import './SimilarAuthors.scss';

const { composeSimilarAuthorLinkClickEvent } = bibEventComposer;
const { CUSTOM_DIMENSIONS } = AnalyticsConstants;

export default function SimilarAuthors({ authorSuggestions }) {
  const source = authorSuggestions.first()?.get('providerName');

  function handleClick() {
    sendAnalyticsEvents(
      composeSimilarAuthorLinkClickEvent({
        containerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.BIB_EXPLORE_FURTHER,
        providerName: source
      })
    );
  }

  if (authorSuggestions.size === 0) return null;

  return (
    <div className="cp-similar-authors">
      <div className="similar-authors-heading">
        <FormattedMessage tagName="h3" id="similar_authors" />
        <VendorAttributionLabel name={source} />
      </div>
      <AuthorsList authors={authorSuggestions} handleClick={handleClick} />
    </div>
  );
}

SimilarAuthors.propTypes = {
  authorSuggestions: ImmutablePropTypes.list.isRequired
};
